module.exports = __webpack_public_path__ + "static/media/yogi-qempo_2.e6966461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/yogi-qempo_2.png
// module id = 260
// module chunks = 0